import { t, Trans } from 'app/shared/i18n';
import React from 'react';
import { MessageResolverMap } from './types';
import { mapFileFormats } from './utils';
import { useStyles } from '../../../pages/Survey/Subject/elements/Messages/styles';

export const infoMap: MessageResolverMap<'info'> = {
  RANGE_DECIMAL: (wording, message) => {
    const { gte, lte, decimal } = message.payload!;
    const upper = lte || lte === 0;
    const lower = gte || gte === 0;
    let rangeMsg = '';
    const decimalPointMsg =
      decimal !== undefined
        ? t(wording.message.info.digit_lowbound, { point: decimal })
        : '';

    if (lower && upper) {
      rangeMsg = `${wording.message.info.need_between} ${gte} ～ ${lte} ${wording.message.info.between}`;
    } else if (lower) {
      rangeMsg = `${wording.message.info.need_upper} ${gte}`;
    } else if (upper) {
      rangeMsg = `${wording.message.info.need_lower} ${lte}`;
    }

    return `${rangeMsg}${
      rangeMsg && decimalPointMsg ? ' ' : ''
    }${decimalPointMsg}`;
  },
  SORT_COUNT: (wording, message) => {
    const { gte } = message.payload!;

    return `${wording.message.info.need_sort} ${gte} ${wording.message.info.option_count.optcount}`;
  },
  FILE: (wording, message) => {
    const useStyle = useStyles();
    const { lte, format } = message.payload!;
    const agent = navigator.userAgent;
    const isAndroid = agent.indexOf('Android') > -1 || agent.indexOf('Adr') > -1;
    const androidMsg = (
      <Trans info={(
        <p className={useStyle.inportantInfo}>{wording.subject.fileupload.info.androidMsg}</p>
      )}>
        {'{{info}}'}
      </Trans>
    )
    const sizeMsg = (
      <Trans filesize={<b>{lte}</b>}>
        {wording.subject.fileupload.info.size}
      </Trans>
    );
    const formatMsg = format && format.length && (
      <Trans filetype={<b>{mapFileFormats(wording, format)}</b>}>
        {wording.subject.fileupload.info.type}
      </Trans>
    );

    return (
      <>
        {isAndroid && androidMsg}
        {sizeMsg}
        {sizeMsg || formatMsg ? ' ' : ''}
        {formatMsg}
      </>
    );
  },
  OPTION_COUNT: (wording, message) => {
    if (message.payload) {
      const { count, gte, lte } = message.payload;

      let finalText = '';

      if (gte && !lte) {
        finalText += `${wording.message.placeholder.select} ${wording.message.info.atleast} ${gte} ${wording.message.info.option_count.optcount}`;
      } else if (!gte && lte) {
        finalText += `${wording.message.placeholder.select} ${wording.message.info.atmost} ${lte} ${wording.message.info.option_count.optcount}`;
      } else if (gte && lte) {
        finalText += `${wording.message.placeholder.select} ${gte} ~ ${lte} ${wording.message.info.option_count.optcount}`;
      }

      if (count) {
        finalText += `（${wording.message.info.option_count.correct.replace(
          '{{count}}',
          `${count}`
        )}）`;
      }

      return finalText;
    }

    return;
  }
};
